module.exports = {"id":"201240","name":"Tom Barkhuizen","rating":"71","photo":"./data/images/photos/4/201240.png","club":{"name":"Preston","logo":"./data/images/clubs/Preston.png"},"positions":["AD","MD","BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TomBarkhuizen0.json
// module id = 4160
// module chunks = 0